import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=2047dd86&scoped=true&"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js&"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSidebar.vue?vue&type=style&index=0&id=2047dd86&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047dd86",
  null
  
)

export default component.exports